import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "../hooks/useAuth";
import { NavLink } from "react-router-dom";
import { AccessModal } from "./AccessModal";
import { ClassListModal } from "./ClassListModal";
import { StudentInstructionModal } from "./StudentInstructionModal";
import "../styles/header.css";
import customLogo from "../assets/imgs/custom-logo.svg";

interface HeaderProps {
  isValidation?: boolean;
  joinClassModalOpen?: boolean;
  setJoinClassModalOpen?: (open: boolean) => void;
  rwdSizeLg?: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  isValidation = true,
  joinClassModalOpen,
  setJoinClassModalOpen,
  rwdSizeLg,
}) => {
  const { isAuthenticated, signIn, user, signOut } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [accessModalOpen, setAccessModalOpen] = useState<boolean>(false);
  const [classListModalOpen, setClassListModalOpen] = useState<boolean>(false);
  const [studentInstructionModalOpen, setStudentInstructionModalOpen] = useState<boolean>(false);
  const [newClassCode, setNewClassCode] = useState<string>("");
  const userMenuRef = useRef<HTMLUListElement>(null);
  const userProfileRef = useRef<HTMLDivElement>(null);
  const isStudentHome = location.pathname === "/student-home";
  // 檢查是否是教師訪問的 feedback 頁面（來自教師相關頁面）
  const isTeacherFeedback = location.pathname === "/feedback" && 
    (document.referrer.includes("/teacher/correcting-records") || 
     document.referrer.includes("/book-preview"));
     
  const isTeacherPage = location.pathname === "/book-preview" || 
                        location.pathname.includes("/teacher/correcting-records") || 
                        isTeacherFeedback;

  // 處理開通成功
  const handleAccessSuccess = (classCode: string) => {
    console.log("🎉 Header - handleAccessSuccess 被調用");
    console.log("🎉 班級邀請碼:", classCode);
    console.log("🎉 設置 studentInstructionModalOpen 為 true");
    setNewClassCode(classCode);
    setStudentInstructionModalOpen(true);
  };


  // 處理用戶標籤點擊事件
  const handleUserLabelClick = (e: React.MouseEvent) => {
    e.preventDefault();

    try {
      // 檢查用戶是否已登入
      if (!isAuthenticated) {
        // 根據當前頁面判斷角色
        const role = isTeacherPage ? "teacher" : "student";
        signIn(role);
      } else {
        // 切換選單狀態
        setIsMenuOpen((prev) => !prev);
      }
    } catch (error) {
      console.error("處理用戶點擊事件失敗", error);
    }
  };

  // 監聽點擊外部區域來關閉選單
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        userProfileRef.current &&
        !userProfileRef.current.contains(event.target as Node)
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header
      className={`${isValidation ? "validation-mode" : ""} ${
        rwdSizeLg ? "lg:py-4 lg:px-xl " : " md:py-4 md:px-xl"
      }  py-4 px-sm`}
    >
      <NavLink
        to="/"
        className="flex items-center"
      >
        <img
          src={customLogo}
          alt="翰林AI寫作批改"
          className="h-10 md:h-11 cursor-pointer"
        />
      </NavLink>
      <div
        className="user-profile"
        ref={userProfileRef}
        style={{ display: !isValidation ? "none" : "block" }}
      >
        <input
          type="checkbox"
          id="user-menu-toggle"
          className="user-menu-toggle"
          checked={isMenuOpen}
          readOnly
        />
        <div className="flex items-center gap-4">
          {isAuthenticated && isTeacherPage && (
            <>
              <button
                onClick={() => setClassListModalOpen(true)}
                className="text-white hover:text-gray-200 underline text-xs sm:text-sm md:text-base font-medium whitespace-nowrap"
              >
                班級列表
              </button>
              {/* <button
                onClick={() => setAccessModalOpen(true)}
                className="text-white hover:text-gray-200 underline text-sm md:text-base font-medium whitespace-nowrap"
              >
                開通班級
              </button> */}
            </>
          )}
          <label className="user-avatar-label" onClick={handleUserLabelClick}>
            <span className="user-avatar"></span>
            <span className="user-name !hidden md:!inline">
              {user?.profile.name || "未登入"}
            </span>
          </label>
        </div>
        <ul
          className="user-menu"
          ref={userMenuRef}
          style={{ display: isMenuOpen ? "block" : "none" }}
        >
          <li className="bg name">
            <span></span>
            {user?.profile.name || "翰林相信學習"}
          </li>
          <li className="Signout">
            <a onClick={signOut}>登出</a>
          </li>
        </ul>
      </div>
      {isStudentHome && (
        <div
          onClick={() => {
            if (setJoinClassModalOpen)
              setJoinClassModalOpen(!joinClassModalOpen);
          }}
          className={`md:pr-28 pr-11 md:text-lg text-base font-medium cursor-pointer`}
        >
          加入班級
        </div>
      )}
      <AccessModal
        open={accessModalOpen}
        onClose={() => setAccessModalOpen(false)}
        onSuccess={handleAccessSuccess}
      />
      <StudentInstructionModal
        open={studentInstructionModalOpen}
        onClose={() => {
          console.log("🎉 Header StudentInstructionModal 關閉");
          setStudentInstructionModalOpen(false);
        }}
        classCode={newClassCode}
      />
      <ClassListModal
        open={classListModalOpen}
        onClose={() => setClassListModalOpen(false)}
      />
    </header>
  );
};